// FaviconBadge.js
import { useEffect } from "react";
import Favico from "favico.js";

function FaviconBadge({ count }) {
  useEffect(() => {
    // Initialize Favico instance
    const favico = new Favico({
      animation: "none", // No animation by default
    });

    // Update the favicon badge based on the count
    if (count > 0) {
      favico.badge(count); // Set the badge count
    } else {
      favico.reset(); // Reset to the default favicon when count is 0
    }

    // Cleanup function to reset the favicon on unmount
    return () => {
      favico.reset();
    };
  }, [count]);

  return null; // This component doesn't render anything visible
}

export default FaviconBadge;
